import { FaPalette, FaSun, FaMoon, FaDesktop, FaCheck } from "react-icons/fa";
import { SectionShell } from "./settings-shared";

const THEME_OPTIONS = [
  { value: "LIGHT", label: "Light", description: "Bright and clean", icon: FaSun },
  { value: "DARK", label: "Dark", description: "Easy on the eyes", icon: FaMoon },
  { value: "SYSTEM", label: "Match system", description: "Follows your device", icon: FaDesktop },
];

export default function AppearanceSection({ formData, onChange }) {
  return (
    <SectionShell id="appearance" icon={FaPalette} title="Appearance" subtitle="How SwiftBoard looks on this device">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        {THEME_OPTIONS.map((opt) => {
          const Icon = opt.icon;
          const active = formData.theme === opt.value;
          return (
            <button
              key={opt.value}
              type="button"
              onClick={() => onChange("theme", opt.value)}
              className={`relative flex items-center gap-2.5 pl-3 pr-7 py-2.5 rounded-lg border text-left ${
                active
                  ? "border-primary bg-primary/[0.08]"
                  : "border-border bg-surface"
              }`}
            >
              <div
                className={`w-7 h-7 rounded-md flex items-center justify-center shrink-0 ring-1 ${
                  active
                    ? "bg-primary/[0.12] ring-primary/20 text-primary"
                    : "bg-surface_alt ring-border text-text_muted"
                }`}
              >
                <Icon size={11} />
              </div>
              <div className="min-w-0">
                <p className={`text-xs font-semibold leading-tight ${active ? "text-primary" : "text-text_primary"}`}>{opt.label}</p>
                <p className="text-[10.5px] text-text_muted mt-0.5 leading-tight">{opt.description}</p>
              </div>
              {active && (
                <span className="absolute top-1/2 -translate-y-1/2 right-2.5 w-3.5 h-3.5 rounded-full bg-primary flex items-center justify-center shrink-0">
                  <FaCheck size={7} className="text-white" />
                </span>
              )}
            </button>
          );
        })}
      </div>
    </SectionShell>
  );
}
